module.exports = __webpack_public_path__ + "static/media/trash-icon.cffcee9c.svg";